import "./error.css";

const Error = () => {
  return (
    <div className="container-fluid default">
      <div>Some thing went wrong!!</div>
    </div>
  );
};

export default Error;
